<template>
	<div class="cbs-calculator-control">
		<legend class="flex justify-between items-center">
			<div>
				{{ localValue.title }}<span class="text-danger" v-if="!localValue.is_optional">&nbsp;*</span>:
			</div>
			<cbs-hint
				v-if="
					localValue.description &&
					localValue.description.enable &&
					localValue.description.position === $constant.DYNAMIC_FORM_FIELD_INFO_POSITION.ICON
				"
				:data="localValue.description && localValue.description.value"
			/>
		</legend>

		<div
			class="my-1"
			v-if="
				localValue.description &&
				localValue.description.enable &&
				localValue.description.position === $constant.DYNAMIC_FORM_FIELD_INFO_POSITION.TOP
			"
		>{{ localValue.description && localValue.description.value }}</div>
		<cbs-input
			v-if="typeof localValue.attributes === 'string' ? JSON.parse(localValue.attributes).show_as_text : false"
			disabled
			class="inputx w-full"
			:value="$helper.numberToWords(localValue.value)"
		/>
		<cbs-masked-input
			v-else
			disabled
			dataType="int"
			class="vs-inputx vs-input--input normal"
			:userSetting="userSettings"
			v-model.number="localValue.value"
		/>
		<div
			class="my-1"
			v-if="
				localValue.description &&
				localValue.description.enable &&
				localValue.description.position === $constant.DYNAMIC_FORM_FIELD_INFO_POSITION.BOTTOM
			"
		>{{ localValue.description && localValue.description.value }}</div>
	</div>
</template>

<script>
import vSelect from "vue-select";
import CbsHint from "@/components/cbs-hint/CbsHint.vue";

export default {
	name: "CalculatorControl",
	inject: ["parentValidator"],
	components: {
		vSelect,
		CbsHint
	},
    props: {
		value: {
			type: Object,
			required: true,
			validator: prop =>
				prop.hasOwnProperty("id") &&
				prop.hasOwnProperty("value") &&
				prop.hasOwnProperty("title") &&
				prop.hasOwnProperty("control") &&
				prop.hasOwnProperty("children") &&
				prop.hasOwnProperty("attributes") &&
				prop.hasOwnProperty("is_optional") &&
				prop.hasOwnProperty("description")
		}
    },
    computed: {
        localValue: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit("input", val);
            }
        }
    },
	created() {
        if (this.parentValidator) {
            this.$validator = this.parentValidator;
		}
	}
}
</script>

<style>

</style>